import React, { Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import ListItem from '@wix/da-ds/pkg/List/ListItem';
import { BiData } from '@wix/da-bi/pkg/events';
import DiscordModuleLoaderLazy from '../../../Discord/redux/ModuleLoaderLazy';
const ConnectDiscord = ({ deviation, subscriberConnect })=>{
    var _deviation_tier_discord, _deviation_tier, _deviation_tier_discord1, _deviation_tier1;
    const { t } = useTranslation();
    if (!((_deviation_tier = deviation.tier) === null || _deviation_tier === void 0 ? void 0 : (_deviation_tier_discord = _deviation_tier.discord) === null || _deviation_tier_discord === void 0 ? void 0 : _deviation_tier_discord.connected)) {
        // The tier author hasn't connected their discord server
        return null;
    }
    if ((_deviation_tier1 = deviation.tier) === null || _deviation_tier1 === void 0 ? void 0 : (_deviation_tier_discord1 = _deviation_tier1.discord) === null || _deviation_tier_discord1 === void 0 ? void 0 : _deviation_tier_discord1.oauth2) {
        return /*#__PURE__*/ React.createElement(Suspense, {
            fallback: null
        }, /*#__PURE__*/ React.createElement(DiscordModuleLoaderLazy, null), /*#__PURE__*/ React.createElement(ListItem, {
            label: t('deviationview.tierCard.moreActionsMenu.item.connectDiscord'),
            onClick: ()=>subscriberConnect(deviation),
            biData: BiData({
                evid: 555,
                itemid: deviation.deviationId
            })
        }));
    }
    return null;
};
ConnectDiscord.displayName = 'ConnectDiscord';
export default ConnectDiscord;
